module.exports = __webpack_public_path__ + "img/logo-headline65x400.8728f809.png";